<script lang="ts">
  import { page } from "$app/state";
  import Breadcrumb from "$lib/Breadcrumb.svelte";
  import type { LayoutData } from "./$types";
  import type { Article } from "$lib/types/article";
  import type { Question } from "$lib/types/shared";
  import LanguagePicker from "$lib/SubLayoutLanguagePicker.svelte";
  import lang from "$lib/langStore";

  type ArticleSlugPage = Article & {
    languages?: string[];
    faq?: {
      heading: string;
      items: Question[];
    };
  };

  let {
    children,
    data,
  }: {
    children?: import("svelte").Snippet;
    data: LayoutData;
  } = $props();

  let article: ArticleSlugPage = $derived(data?.sanity?.options?.initial?.data);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let categories = $derived(article?.categories?.map((x: any) => x.name.toLowerCase()) || []);
  let breadcrumbs = $derived(
    [
      { href: "/", label: "Forside" },
      { href: "/om/aktuelt", label: "Aktuelt" },
      ...(categories.includes("sparetips")
        ? [{ href: "/om/aktuelt/sparetips", label: "Sparetips" }]
        : []),
      {
        href: page.url.pathname,
        label: `${(!$lang ? article?.title : "Oversatt artikkel") || "artikkel"}`,
      },
    ].filter(Boolean)
  );
</script>

<Breadcrumb {breadcrumbs} />

{#if (data?.languages?.length || 1) > 1}
  <LanguagePicker href={page.url.pathname} languages={data?.languages}>
    {@render children?.()}
  </LanguagePicker>
{:else}
  {@render children?.()}
{/if}
